export enum CacheTarget {
    Cache = 'cache',
    Timelimit = 'timelimit',
    Locks = 'locks',
    Pubsub = 'pubsub',
    Queue = 'queue',
    All = 'all',
}
